import React from "react";
import Banner from "../../components/Widgets/Banner";

const Shop = () => {
    return (
        <div className="shop">
            <Banner route="shop">

            </Banner>
        </div>
    )
}

export default Shop;